import { render, staticRenderFns } from "./Checkbox2.vue?vue&type=template&id=7155f75c&scoped=true&"
import script from "./Checkbox2.vue?vue&type=script&lang=js&"
export * from "./Checkbox2.vue?vue&type=script&lang=js&"
import style0 from "./Checkbox2.vue?vue&type=style&index=0&id=7155f75c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7155f75c",
  null
  
)

export default component.exports